import { Power1 } from "gsap";
import React, { MouseEvent } from "react";
import Common from "./Common";

import "./Notifications.css";

const time_in = 316;
const time_show = 1033;
const time_out = 250;

export default class Notifications extends React.Component<Notifications.Props, Notifications.State>
{

    ref: React.RefObject<HTMLDivElement>;
    animationFrame: number;
    keyID: number;

    constructor(props: Notifications.Props)
    {
        super(props);

        this.keyID = 1000;

        this.ref = React.createRef();

        window.notifications = this;
        
        this.state = {
            notifications: []
        };
        this.animate = this.animate.bind(this);
    }


    animate()
    {
        for (let i = 0; i < this.state.notifications.length; i++)
        {
            const notification = this.state.notifications[i];

            const item = notification.ref.current;
            if (item)
            {
                let style = notification.style;
                if (!style)
                {
                    const computed = window.getComputedStyle(item);
                    style = notification.style = {
                        height: Number(computed.height.replace("px", "")),
                        marginTop: Number(computed.marginTop.replace("px", "")),
                        marginBottom: Number(computed.marginBottom.replace("px", "")),
                        paddingTop: Number(computed.paddingTop.replace("px", "")),
                        paddingBottom: Number(computed.paddingBottom.replace("px", ""))
                    };
                }

                let t = performance.now() - notification.time;
                
                if (t < time_in)
                {
                    const p = Power1.easeOut(t / time_in);
                    item.style.opacity = p.toString();
                    item.style.transform = "translateY(" + (100 - 100 * p) + "%)";
                }
                else if (t < time_in + notification.duration)
                {
                    item.style.opacity = "1";
                    item.style.transform = "translateY(0%)"
                }
                else if (t < time_in + notification.duration + time_out)
                {
                    const p = Power1.easeInOut((t - time_in - notification.duration) / time_out);
                    const pi = 1 - p;

                    item.style.opacity = Math.max(1 - p, 0).toString();
                    item.style.height = (style.height * pi) + "px";
                    item.style.marginTop = (style.marginTop * pi) + "px";
                    item.style.marginBottom = (style.marginBottom * pi) + "px";
                    item.style.paddingTop = (style.paddingTop * pi) + "px";
                    item.style.paddingBottom = (style.paddingBottom * pi) + "px";
                }
                else
                {
                    this.state.notifications.splice(i, 1);
                    this.setState({
                        notifications: this.state.notifications
                    });
                    i--;
                }
            }
        }
        
        if (this.state.notifications.length > 0)
        {
            this.animationFrame = requestAnimationFrame(this.animate);
        }
        else
        {
            this.animationFrame = null;
        }
    }


    win(multiplier: number, win: number, currency: string, isWin: boolean)
    {
        const ref: React.RefObject<HTMLDivElement> = React.createRef();
        const key = "notification_" + this.keyID++;
        this.state.notifications.push({
            type: "win",
            message: {
                multiplier,
                win,
                currency,
                isWin
            },
            duration: time_show,
            ref: ref,
            key: key,
            time: performance.now()
        });

        this.setState({
            notifications: this.state.notifications
        });

        if (!this.animationFrame)
        {
            this.animationFrame = requestAnimationFrame(this.animate);
        }
    }


    message(message: string)
    {
        const ref: React.RefObject<HTMLDivElement> = React.createRef();
        const key = "notification_" + this.keyID++;
        this.state.notifications.push({
            type: "message",
            message: message,
            duration: time_show,
            ref: ref,
            key: key,
            time: performance.now()
        });

        this.setState({
            notifications: this.state.notifications
        });
        
        if (!this.animationFrame)
        {
            this.animationFrame = requestAnimationFrame(this.animate);
        }
    }


    warning(message: string, update_key?: string)
    {
        if (update_key && this.state.notifications.find(n => n.key == update_key))
        {
            this.update(update_key, message);
            return update_key;
        }
        
        const ref: React.RefObject<HTMLDivElement> = React.createRef();
        const key = "notification_" + this.keyID++;
        this.state.notifications.push({
            type: "warning",
            duration: Number.POSITIVE_INFINITY,
            ref: ref,
            key: key,
            message: message,
            time: performance.now()
        });

        this.setState({
            notifications: this.state.notifications
        });

        if (!this.animationFrame)
        {
            this.animationFrame = requestAnimationFrame(this.animate);
        }
        
        return key;

    }


    error(message: string)
    {
        const ref: React.RefObject<HTMLDivElement> = React.createRef();
        const key = "notification_" + this.keyID++;
        this.state.notifications.push({
            type: "error",
            message: message,
            duration: time_show,
            ref: ref,
            key: key,
            time: performance.now()
        });

        this.setState({
            notifications: this.state.notifications
        });
        
        if (!this.animationFrame)
        {
            this.animationFrame = requestAnimationFrame(this.animate);
        }
    }


    update(key: string, message: string)
    {
        const notification = this.state.notifications.find(n => n.key == key);
        notification.message = message;

        this.setState({
            notifications: this.state.notifications
        });
    }


    close(key: string)
    {
        const notification = this.state.notifications.find(n => n.key == key);
        if (!notification)
        {
            return;
        }

        notification.duration = performance.now() - notification.time - time_in;

        this.setState({
            notifications: this.state.notifications
        });
    }


    pauseOnOver(key: string)
    {
        const notification = this.state.notifications.find(n => n.key == key);

        if (notification.duration - (performance.now() - notification.time - time_in) > 0)
        {
            notification.duration = Number.POSITIVE_INFINITY;
        }

    }


    resumeOnOut(key: string)
    {
        const notification = this.state.notifications.find(n => n.key == key);

        if (notification.duration - (performance.now() - notification.time - time_in) > 0)
        {
            notification.duration = performance.now() - notification.time - time_in + time_show;
        }
    }


    componentDidMount()
    {
        
    }


    render()
    {
        return (
            <div
                id="notifications"
            >
                
                {this.renderNotifications()}

            </div>
        );
    }


    renderNotifications()
    {
        const arr: Array<JSX.Element> = [];

        this.state.notifications.forEach(notification => {
            switch (notification.type)
            {
                case "win":
                    arr.push(this.renderWin(notification));
                    break;

                case "message":
                    arr.push(this.renderMessage(notification));
                    break;

                case "warning":
                    arr.push(this.renderWarning(notification));
                    break;

                case "error":
                    arr.push(this.renderError(notification));
                    break;
            }
        });

        return arr;
    }


    renderWin(data: Notifications.Notification)
    {
        const contentData = data.message as Notifications.NotificationWinData;
        return (
            <div
                className={"item cashout " + (contentData.isWin ? "green" : "grey")}
                onMouseEnter={this.pauseOnOver.bind(this, data.key)}
                onMouseLeave={this.resumeOnOut.bind(this, data.key)}
                key={data.key}
                ref={data.ref}
            >
                
                <div className="multiplier">
                    <div className="title font_low">
                        {lang.shared["ui-components"].toastr["toastr-message"]["You have cashed out!"]}
                    </div>
                    <div className="value">
                        {contentData.multiplier.toFixed(2)}x
                    </div>
                </div>

                <div className="win">
                    <div className="title font_low">
                        {lang.shared.win}, {currency}
                    </div>
                    <div className="value">
                        {Common.renderCurrency(contentData.win, contentData.currency)}
                    </div>
                </div>

                <div 
                    className="button"
                    onClick={this.close.bind(this, data.key)}
                >
                    ×
                </div>

            </div>
        );
    }


    renderMessage(data: Notifications.Notification)
    {
        return (
            <div
                className="item green"
                onMouseEnter={this.pauseOnOver.bind(this, data.key)}
                onMouseLeave={this.resumeOnOut.bind(this, data.key)}
                key={data.key}
                ref={data.ref}
            >
                    <div
                        className="label"
                    >
                        {data.message}
                    </div>
            </div>
        );
    }


    renderWarning(data: Notifications.Notification)
    {
        return (
            <div
                className="item orange"
                key={data.key}
                ref={data.ref}
            >
                    <div
                        className="label"
                    >
                        {data.message}
                    </div>
            </div>
        );
    }


    renderError(data: Notifications.Notification)
    {
        return (
            <div
                className="item red"
                onMouseEnter={this.pauseOnOver.bind(this, data.key)}
                onMouseLeave={this.resumeOnOut.bind(this, data.key)}
                ref={data.ref}
                key={data.key}
            >
                    <div
                        className="label"
                    >
                        {data.message}
                    </div>

                    <div 
                        className="button"
                        onClick={this.close.bind(this, data.key)}
                    >
                        ×
                    </div>
            </div>
        );
    }


}

export namespace Notifications
{

    export interface Props
    {

    }

    export interface State
    {
        notifications: Array<Notification>
    }


    export interface NotificationWinData
    {
        multiplier: number;
        win: number;
        currency: string;
        isWin: boolean;
    }


    export interface Style
    {
        height: number;
        marginTop: number;
        marginBottom: number;
        paddingTop: number;
        paddingBottom: number;
    }


    export interface Notification
    {
        type: "win" | "message" | "warning" | "error";
        key: string;
        ref: React.RefObject<HTMLDivElement>;
        duration: number;

        message: string | NotificationWinData;
        
        time?: number;
        style?: Style;
    }

}